import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.css']
})
export class NotFoundComponent implements OnInit {

  constructor(public authService: AuthService) { }

  ngOnInit() {
    
  }

}



// WEBPACK FOOTER //
// ./src/app/not-found/not-found.component.ts